export default class Publisher {
  id: string
  company?: string
}

export function publisherDisplayName(publisher?: Partial<Publisher>): string {
  return publisher?.company || ''
}
